/* global PRODUCTION */

// dependencies
import Cookies from "js-cookie";
import { replace } from "yarrr";

// selectors
import { getPageIsPublic } from "Selectors/app";

// actions
import { setupAuthenticatedEnvironment } from "Actions/authentication";

export const changeEnvironment = (environment) => (dispatch) => {
	dispatch({ type: "APP:ENVIRONMENTCHANGE", environment });
};

export const SetupUnauthenticatedEnvironment = () => (dispatch) => {
	Cookies.remove("logan-auth-token");
	dispatch({ type: "APP:UNAUTHENTICATED" });

	// redirect to login page
	dispatch(replace("/login/"));
};
/**
 * Check if user is authenticated
 * @returns Boolean
 * @constructor
 * read from secure cookie logan-auth-token
 * If it's undefined or null return false
 * If mfaLoginPassed property is true, return true, else false
 * False will let the browser no this user can't access Logan
 * and redirect to mfa-login
 */
export const AmIAuthenticated = () => (dispatch, getState) => {
	const state = getState();
	const pageIsPublic = getPageIsPublic(state);

	if (pageIsPublic) {
		return false;
	}

	const loganToken = Cookies.get("logan-auth-token");
	if (loganToken === "undefined" || !loganToken) {
		return false;
	}
	const parsedToken = JSON.parse(atob(loganToken));

	return parsedToken.mfaLoginPassed;
};

export const applicationInit = () => async (dispatch) => {

	const isProduction = !!PRODUCTION;
	dispatch({ type: "APP:INITIALIZE", isProduction });

	// Check if it's the callback route
	const isCallbackRoute =
		window.location.pathname === "/auth/google/callback" || window.location.pathname === "/auth/google/callback/";

	// Only do a full authentication check if it's NOT the callback route
	// If it IS the callback route, authentication check will be done later in GoogleCallback component
	if (!isCallbackRoute) {
		const isAuthenticated = dispatch(AmIAuthenticated());

		if (isAuthenticated) {
			dispatch(setupAuthenticatedEnvironment());
		} else {
			dispatch(SetupUnauthenticatedEnvironment());
		}
	}
};
